import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { PRIMARY, PRIMARY_LIGHT } from '../../theme';

// Plain ring spinner (WhatsApp-style) for the chat screens — a faint track with
// a rotating arc, no logo in the middle.
export default function ChatLoader({ size = 40 }) {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex', width: size, height: size }}>
            <CircularProgress variant="determinate" value={100} size={size} thickness={4} sx={{ color: PRIMARY_LIGHT, position: 'absolute', inset: 0 }} />
            <CircularProgress size={size} thickness={4} disableShrink sx={{ color: PRIMARY, position: 'absolute', inset: 0, '& .MuiCircularProgress-circle': { strokeLinecap: 'round' } }} />
        </Box>
    );
}
